import { action, computed, observable, makeObservable } from 'mobx';
import { baseUrlService } from 'ui-toolkit/rest/BaseUrlService';
import { OrderDetails } from '../classes/OrderDetails';

export interface IAppData {
  order: OrderDetails;
  railsUrl: string;
  countyFips: string;
  submitButtonDisable: boolean;
}

const appDefaultData: IAppData = {
  countyFips: '',
  order: new OrderDetails(),
  railsUrl: '',
  submitButtonDisable: true,
};

export class AppService {
  public appData: IAppData = appDefaultData;

  constructor() {
    makeObservable(this, {
      appData: observable,
      setRailsUrl: action,
      setCountyFips: action,
      setSubmitButton: action,
      getLoginPage: computed,
      setOrderData: action,
      getOrderData: computed,
      getCountyFips: computed,
      BASE_URL: computed,
      getSubmitButtonDisable: computed,
    });
  }

  public setRailsUrl(): string {
    return baseUrlService.WebsiteLocation;
  }

  public setCountyFips(county: string) {
    this.appData.countyFips = county;
  }

  public setSubmitButton(disable: boolean) {
    this.appData.submitButtonDisable = disable;
  }

  public get getLoginPage(): string {
    return `${this.BASE_URL}/lenders/sign_in`;
  }

  public setOrderData(data: OrderDetails) {
    this.appData.order = data;
  }

  public get getOrderData(): OrderDetails {
    return this.appData.order;
  }

  public get getCountyFips() {
    return this.appData.countyFips;
  }

  public get BASE_URL(): string {
    return this.appData.railsUrl;
  }

  public get getSubmitButtonDisable(): boolean {
    return this.appData.submitButtonDisable;
  }
}
